const URI_GLOBAL = '';

export const environment = {
  production: false,
  apiFramework: 'https://framework.fitrus.com.br/v8',
  api: 'https://api.fitrus.com.br/v1',
  urlWebSocket: 'https://api.fitrus.com.br/signalR',
  notAuthorizedRoute: '/miscellaneous/notauthorized',
  expireTimeFingerprint: 30,
  applicationName: 'SGA',
  login: {
    enableRegister: false,
    enableNickName: false,
    providers: [],
    redirect: '/'
  },
  resource: {
    prefix: `/assets/i18n/`,
    suffix: '.json'
  },
  appVersion: require('../../package.json').version + '-dev'
};
